<!--  -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb></breadcrumb>
    </div>
    <div class="search-ctn">
      <div class="search-ctn-left">
        <div class="search-name" style="color:#303133;">本月总收入：</div>
        <div
          class="search-name"
          style="color:#303133;margin-left:0px;font-weight:bold;font-size:medium;"
        >￥{{incomeData.TotalIncomeAmount}}</div>
        <div class="search-name" style="color:#303133;">本月总支出：</div>
        <div
          class="search-name"
          style="margin-left:0px;font-weight:bold;font-size:medium;color:red;"
        >￥{{incomeData.TotalExpenseAmount}}</div>
        <div class="search-name">
          <el-button
            size="small"
            class="search-btn btn-primary"
            @click="gotoWithdraw"
            v-if="permission.withdraw"
          >{{permission.withdraw}}</el-button>
        </div>
      </div>
      <div class="search-ctn-right">
        <div class="search-name">时间</div>
        <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
        <el-button
          size="small"
          icon="el-icon-search"
          class="search-btn btn-primary"
          @click="getIncomeMain"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          class="search-btn btn-primary"
          @click="resetSearch"
        >重置</el-button>
      </div>
    </div>
    <el-card class="box-card">
      <div class="data-count">
        <div class="data-item">
          <p>预约数</p>
          <p>{{incomeMain.RepairReservationCount}}</p>
        </div>
        <div class="data-item">
          <p>订单数</p>
          <p>{{incomeMain.RepairOrderCount}}</p>
        </div>
        <div class="data-item">
          <p>顾客数</p>
          <p>{{incomeMain.RepairOrderCustomerCount}}</p>
        </div>
        <div class="data-item">
          <p>单笔均价</p>
          <p>￥{{incomeMain.RepairOrderAveragePrice}}</p>
        </div>
        <div class="data-item">
          <p>维修订单金额</p>
          <p>￥{{incomeMain.RepairOrderTotalAmount}}</p>
        </div>
        <div class="data-item">
          <p>采购数</p>
          <p>￥{{incomeMain.PurchaseOrderCount}}</p>
        </div>
        <div class="data-item">
          <p>采购金额</p>
          <p>￥{{incomeMain.PurchaseOrderTotalAmount}}</p>
        </div>
        <div class="data-item border-right-none">
          <p>服务费收入</p>
          <p>{{incomeMain.RepairOrderTotalServiceAmount}}</p>
        </div>
      </div>
    </el-card>
    <div class="echart-ctn" id="echartCtn"></div>
    <el-dialog :close-on-click-modal="false" title="时间" :visible.sync="timeVisible" width="800px">
      <div class="dialog-content" v-if="timeVisible">
        <timePicker
          @timerSearch="timerSearch"
          :start="this.searchData.BeginDate"
          :end="this.searchData.EndDate"
        ></timePicker>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
import timePicker from "@/components/common/timePicker";
export default {
  mixins: [mixin],
  components: {
    timePicker,
    breadcrumb
  },
  name: "",
  data() {
    return {
      timeVisible: false,
      permission: {},
      incomeData: {},
      incomeMain: {},
      searchData: {
        EntpId: this.$util.getLocalStorage("userMsg").EntpId,
        BeginDate: "",
        EndDate: ""
      },
      date: [],
      income: [],
      output: []
    };
  },
  mounted() {
    this.getIncomeData();
    this.getIncomeMain();
    // this.$util.setEnterEvent(this, this.$route.fullPath).then(() => {
    //   this.getIncomeData();
    //   this.getIncomeMain();
    // });
    let fullPath = this.$route.fullPath;
    document.onkeydown = event => {
         let isDialog =document.querySelector(".v-modal");
        let layui=document.querySelectorAll(".layui-layer");       
      if (fullPath == this.$route.fullPath&&!isDialog&&layui.length<=1) {
        let e = event || window.event || arguments.callee.caller.arguments[0];
        if (e && e.keyCode == 13) {
          this.getIncomeData();
          this.getIncomeMain();
        }
      }
    };
    this.permission = this.$util.getPermission("Withdraw");
  },
  methods: {
    timerSearch(timer) {
      this.timeVisible = false;
      this.searchData.BeginDate = timer.start;
      this.searchData.EndDate = timer.end;
      this.getIncomeMain();
    },
    resetSearch() {
      this.searchData = {
        EntpId: this.searchData.EntpId,
        BeginDate: "",
        EndDate: ""
      };
    },
    // 跳转提现页面
    gotoWithdraw() {
      this.$router.push("./withdraw");
    },
    // 获取本月收支统计
    getIncomeMain() {
      this.$util
        .axiosGet({
          url: "/api/RevenueManagement/GetCurrentMonthIncomeExpenseStatistics",
          data: this.searchData
        })
        .then(res => {
          this.date = [];
          this.income = [];
          this.output = [];
          let data = res.data;
          this.incomeMain = data;
          let _mapData = data.Detail;
          for (let i = 0; i < _mapData.length; i++) {
            this.date.push(_mapData[i].Date);
            this.income.push(_mapData[i].IncomeAmount);
            this.output.push(_mapData[i].ExpenseAmount);
          }
          this.initEchart();
        })
        .catch(() => {});
    },
    // 获取本月收支值
    getIncomeData() {
      this.$util
        .axiosGet({
          url: "/api/RevenueManagement/GetCurrentMonthIncomeExpenseSummary",
          data: {
            entpId: this.searchData.EntpId
          },
          hideLoading: true
        })
        .then(res => {
          let data = res.data;
          this.incomeData = data;
        })
        .catch(() => {});
    },
    initEchart() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("echartCtn"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "收入支出图"
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["本月收入", "本月支出"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.date
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "收入",
            type: "line",
            data: this.income
          },
          {
            name: "支出",
            type: "line",
            stack: "总量",
            data: this.output
          }
        ]
      });
    }
  }
};
</script>
<style lang="less" scoped>
.data-count {
  padding: 20px;
  display: flex;
  .data-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 12.5%;
    border-right: 1px solid @border4Color;
    > p:nth-child(1) {
      margin-bottom: 20px;
      color: @font3Color;
    }
  }
}
.echart-ctn {
  margin-top: 20px;
  height: 500px;
}
</style>
